var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { ADDRESS_REGEX, ALPHA_NUMERIC_REGEX, ALPHA_REGEX, NUMERIC_REGEX, ValidationType, forbiddenKeys } from "@/utils/Common";
import { TextField } from "@mui/material";
const CustomTextField = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(TextField, Object.assign({}, props, { onKeyDown: (event) => {
            if (!forbiddenKeys.includes(event.key)) {
                if (props.validation === ValidationType.numeric) {
                    if (event.ctrlKey) {
                        return;
                    }
                    if (!NUMERIC_REGEX.test(event.key)) {
                        event.preventDefault();
                    }
                }
                else if (props.validation === ValidationType.alpha) {
                    if (!ALPHA_REGEX.test(event.key)) {
                        event.preventDefault();
                    }
                }
                else if (props.validation === ValidationType.alphaNumeric) {
                    if (!ALPHA_NUMERIC_REGEX.test(event.key) && !/[\s,]/.test(event.key)) {
                        event.preventDefault();
                    }
                }
                else if (props.validation === ValidationType.address) {
                    if (!ADDRESS_REGEX.test(event.key)) {
                        event.preventDefault();
                    }
                }
                // else if (props.validation === ValidationType.email) {
                //   if (!EMAIL_REGEX.test(event.key)) {
                //     event.preventDefault();
                //   }
                // }
            }
        } })));
};
export default CustomTextField;
